<template>
		<div class="index-top">
			<div class="index-banner" :class="{indexBanner2:route!='index'}">
				<div class="banner-content indexCenter">
					<div class="banner-top">
						<div class="banner-web">
							<template  v-for="item,index in linkData" :key="item.id">
								<a-divider class="lineBox" type="vertical" v-if="index"/>
								<a target="_blank" :href="item.furl">{{ item.fname }}</a>
							</template>
							<a-divider class="lineBox" type="vertical" />
							<a target="_blank" href="https://sq.yqskjt.com/apps/yangquan_smart_community/admin/">智慧社区服务平台</a>

							<!-- <a href="#">山西省政府</a>
							<a-divider class="lineBox" type="vertical" />
							<a href="#">阳泉市政府</a>
							<a-divider class="lineBox" type="vertical" />
							<a href="#">阳泉高新技术产业开发区</a> -->
						</div>


						<div class="banner-user">
							<div class="rightBox" v-if="user.userName">
									<a-dropdown>
										<template #overlay>
											<a-menu style="margin-top:10px">
												<a-menu-item key="1">
													<a class="account-btn" @click="onChangePass"><lock-outlined/> 修改密码</a>
												</a-menu-item>
												<a-menu-item key="3">
													<a @click="onLogout()">
														<PoweroffOutlined /> 退出登录
													</a>
												</a-menu-item>
												
											</a-menu>
										</template>
										<a class="ant-dropdown-link" style="position:relative;padding:0 10px 0 10px"
											@click="islogin">
											<img  src="@/assets/img/login.png" alt="">
											<span style="margin-left:10px;">{{user.userName}}</span>
										</a>
									</a-dropdown>
							</div>
							<div class="rightBox" v-else>
								<div class="loginBox">
									<img src="@/assets/img/login.png" />
									<!-- <a-dropdown> -->
									<span @click="goMore('/login', 'user')" style="margin-left: 10px;">登录</span>
									<!-- <template #overlay>
											<a-menu>
												<a-menu-item>
													<span @click="goMore('/login', 'manage')">管理员</span>
												</a-menu-item>
												<a-menu-item>
													<span @click="goMore('/login', 'user')">普通用户</span>
												</a-menu-item>
											</a-menu>
										</template> -->
									<!-- </a-dropdown> -->
								</div>
								<a-divider class="lineBox" type="vertical" />
								<div class="resigierBox" @click="this.$router.push('/register')">注册</div>
							</div>

							<div class="rightBox" style="margin-right:20px;position:relative">

								<!-- <a-button v-if="startLogin" style="position:absolute;top:30px;right:100px" @click="goMore('/registerStatus')">
								查看审核状态 </a-button> -->
								<a-dropdown>
									<template #overlay>
										<a-menu style="margin-top:10px">
											<a-menu-item @click="goMoreNotice('/Innovation/index', { type: '首页' })" key="2">
												创新创业
											</a-menu-item>
											<a-menu-item @click="goMoreNotice('/achievements/index', { type: '首页' })" key="6">
												成果转化
											</a-menu-item>
											<a-menu-item @click="goMoreNotice('/knowledge/index', { type: '首页' })" key="4">
												知识产权
											</a-menu-item>
											<a-menu-item @click="goMoreNotice('/finance/index', { type: '首页' })" key="3">
												科技金融
											</a-menu-item>
											<!-- goHttp('https://www.yqgxqsc.com/talent/#/home') -->
											<a-menu-item @click="goHttp('https://www.yqgxqsc.com/talent/#/home')" key="5">
												科技人才
											</a-menu-item>
										</a-menu>
									</template>
									<a class="ant-dropdown-link" @click="goMore('/')">
										<!-- <HomeOutlined />  -->
										首页
										<DownOutlined />
									</a>
								</a-dropdown>

							</div>


						</div>
					</div>


					<div class="home-logo">
						<img src="@/assets/home/home-logo.png" alt="" @click="goJump('/index')">
					</div>


				</div>
			</div>

			<div class="index-nav" v-if="routes.includes(route)">
				<ul class="indexCenter">
					<li  :class="{liSelect:route=='index'}" @click="goJump('/index')">首页</li>
					<li @click="goMorePolicy(1)" :class="{liSelect:route=='notice1'}">通知公告</li>
					<li @click="goMorePolicy(2)" :class="{liSelect:route=='notice2'}">政策动态</li>
					<li :class="{liSelect:route=='enterprise'}">
						<a-dropdown>
							<a >企业服务</a>

							<template #overlay>
								<a-menu style="margin-top:10px">
									<a-menu-item @click="goMore('/integral')" key="2">
										企业创新积分制
									</a-menu-item>
									<a-menu-item  @click="goProjectReview" key="3">
										信息化项目评审
									</a-menu-item>
									<a-menu-item @click="goMore('/materializePolicy/Add')" key="4">
										政策兑现
									</a-menu-item>
									<a-menu-item @click="valiJWT()" key="6">
										新办经营主体刻章服务
									</a-menu-item>

								</a-menu>
							</template>
						</a-dropdown>
					</li>
					<li>
						<a-dropdown>
							<a >创新服务</a>

							<template #overlay>
								<a-menu style="margin-top:10px">
									<a-menu-item @click="goMoreNotice('/Innovation/index', { type: '首页' })" key="2">
										创新创业
									</a-menu-item>
									<a-menu-item @click="goMoreNotice('/achievements/index', { type: '首页' })" key="6">
										成果转化
									</a-menu-item>
									<a-menu-item @click="goMoreNotice('/knowledge/index', { type: '首页' })" key="4">
										知识产权
									</a-menu-item>
									<a-menu-item @click="goMoreNotice('/finance/index', { type: '首页' })" key="3">
										科技金融
									</a-menu-item>
									<!-- goHttp('https://www.yqgxqsc.com/talent/#/home') -->
									<a-menu-item @click="goHttp('https://www.yqgxqsc.com/talent/#/home')" key="5">
										科技人才
									</a-menu-item>
								</a-menu>
							</template>
						</a-dropdown>
					</li>
				</ul>
			</div>
            <div class="hearder-line" v-else></div>

            <a-modal v-model:visible="chapterShow" title="刻章服务">
			<div style="width: 100%;height:260px;position:relative">
				<div ref="SealServiceShow" style="position:absolute;
				margin: 0 auto;
				text-align: center;
				background: #fff;" :class="{ SealServiceActive: SealServiceShow == 1 }">
					<!-- EnterpriseSealServiceLogin -->
					<a-modal v-model:visible="isShow" title="请填写当前计算式的答案" @ok="valiKaptcha">
						<img style="float:left" @click="subPhone" :src="kaptcha" alt="">
						<a-input style="width:120px;margin-left:50px;font-size:22px;height:50px" v-model:value="kaptchanum"
										placeholder="答案" />
					</a-modal>
					<a-form v-if="SealServiceShow == 1" class="login-form" ref="ruleForm" layout="horizontal" :model="form"
						:rules="rules">

                    <div class="tipphone">
                        <p>详情请咨询：0353-2292800/0353-2292128</p>
                    </div>

							<a-col v-if="valiJWTShow" :span="10">
								<a-form-item :label-col="{ style: 'width:90px' }" name="phoneNumber" label="手机号">
									<a-input style="position:relative;margin-right:20px;" v-model:value="form.phoneNumber"
										placeholder="请输入手机号">
										<template #prefix>
											<PhoneOutlined class="tc-gray" />
										</template>
										<template #addonAfter>
											<a-botton style="cursor: pointer;" @click="subPhone()">{{ codeBtnWord }}</a-botton>
											<div class="codeBtnWordMark" ref="codeBtnWordMarkid">

											</div>
										</template>
									</a-input>
								</a-form-item>
							</a-col>

							<a-col v-if="valiJWTShow" :span="6">
								<a-form-item :label-col="{ style: 'width:120px;margin-left:-30px' }" name="watmal" label="手机验证码">
									<a-input style="margin-right:20px;" v-model:value="form.watmal" placeholder="请输入手机验证码">
										<template #prefix>
											<LockOutlined class="tc-gray" />
										</template>
										<template #addonAfter>

										</template>
									</a-input>
								</a-form-item>
							</a-col>
					</a-form>

					<div v-if="!valiJWTShow">账号：{{form.phoneNumber}}</div>

				</div>
			</div>

			<template #footer>
				<template v-if="valiJWTShow">
					<a-button style="margin-right:20px" @click="SealPost(1, 'SealService')">去刻章</a-button>
					<a-button style="margin-right:20px" @click="SealPost(2, 'SealService')">查询</a-button>
					<a-button @click="chapterShow = false;SealServiceShow = 0; form.phoneNumber = null; form.watmal = null">取消</a-button>
				</template>
				<template v-else>
					<a-button style="margin-right:20px;margin-left:50px;margin-bottom:24px" @click="SealPost(1, 'SealService')">去刻章</a-button>
					<a-button style="margin-right:20px" @click="SealPost(2, 'SealService')">查询</a-button>
					<a-button style="margin-right:20px" @click="chapterShow = false;SealServiceShow = 0;form.phoneNumber = null; form.watmal = null">取消</a-button>
					<a-button @click="delJWT()">退出</a-button>
				</template>
			</template>
		</a-modal>

		<EditPasswordModal ref="editPasswordModal" @finish="logout"/>
		</div>
</template>

<script>
import {message, notification} from "ant-design-vue";
import {phoneCommon} from "@/api/finance"
import { getWLinkPage} from "@/api/homeService";
import { login_mp,kaptcha} from "@/api/adminService";
import dataCheck from "@/utils/dataCheck";
import {jwtToken} from "@/api/materializePolicy";
import {ls} from "@/utils/util"
import axios from "axios";
import EditPasswordModal from "@/views/sys/knowledge/visit";

export default {
	components:{EditPasswordModal},
    props:{
        route:{
            type:String,
            default:()=>''
        }
    },
	data() {
		return {
            linkData: [],
            user:{},
            routes:['index','notice1','notice2','enterprise'],
            valiJWTShow:false,
            kaptchanum:'',
            kaptcha:null,
			isShow: false,
			SealServiceShow: 0,
			codeBtnWord: '获取短信验证码',
			startLogin: true,
			visible: false,
			form: {
				phoneNumber: null,
				watmal: null,
			},
            chapterShow:false,
			rules: {
				phoneNumber: [
					dataCheck.required({ msg: '手机号不能为空' }), dataCheck.mobile_phone
				],
				watmal: [
					dataCheck.required({ msg: '验证码不能为空' }),
				],
			},
		}
	},
    async mounted() {
		this.getLink()
        if (ls.get('token') && ls.get("refresh_token")) {
			this.user.userName = this.$ls.get('userName')
			
			this.user.phoneNumber = ls.get('phoneNumber')
		}
    },
    methods: {
        valiKaptcha(){
			// this.subPhone()
			axios({
				method: 'get',
				url: kaptcha.verifykaptcha,
				params: {
					phone:this.form.phoneNumber,
					num:this.kaptchanum
				}
			}).then(res => {
				if(res.data.data){
					this.isShow = false;
					this.getPhoneCode()
				}else{
					this.subPhone()
					message.warning ('请重新计算，答案错误');
				}
			})

		},
        getPhoneCode() {
			this.$refs.ruleForm
				.validate('phoneNumber')
				.then((value) => {
					this.postAction({
						url: phoneCommon.sealSMS,
						params: {
							phone: value.phoneNumber
						}
					}
					).then((res) => {
						if (res.code == '0') {
							this.waitTime = (res.msg * 60) + 1
							this.waitTime--;
							this.$refs.codeBtnWordMarkid.style.zIndex = 1
							this.codeBtnWord = `${this.waitTime}s 后获取`;
							let timer = setInterval(() => {
								if (this.waitTime > 1) {
									this.waitTime--;
									this.codeBtnWord = `${this.waitTime}s 后获取`;
								} else {
									clearInterval(timer);
									this.codeBtnWord = "获取短信验证码";
									this.$refs.codeBtnWordMarkid.style.zIndex = -1
									this.waitTime = 61;
								}
							}, 1000);
							notification.success({
								message: '验证码发送成功，请查看手机短信',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '1') {
							notification.success({
								message: '验证码发送失败，请稍后重新发送',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '2') {
							notification.success({
								message: res.msg,
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '3') {
							notification.success({
								message: res.msg,
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						}
					})
				})
		},
        SealPost(n) {
			if(this.valiJWTShow){
				var valiSome = ['watmal', 'phoneNumber']
				this.$refs.ruleForm.validate(valiSome).then(() => {
					this.postAction({
						url: phoneCommon.sealSMSCheck,
						params: {
							code: this.form.watmal,
							phone: this.form.phoneNumber
						}
					}).then((res) => {
						if (res) {
							this.$notification.success({
								message: '验证码正确，请继续操作',
								duration: 10,
								style: {
									width: '400px',
									fontWeight: '600',
									marginTop: `${10}%`,
								},
							});
				ls.set('jwtphone', this.form.phoneNumber);
				this.getJWT(n)
						} else {
							this.$notification.error({
								message: '验证码有误，请输入正确验证码',
								duration: 10,
								style: {
									width: '400px',
									fontWeight: '600',
									marginTop: `${10}%`,
								},
							});
						}
					})

				})
			}else{
				if (n == 1) {
							this.goMore('/EnterpriseSealService/Add', this.form.phoneNumber, 'add')
						} else if (n == 2) {
							this.goMore('/EnterpriseSealService', this.form.phoneNumber, 'list')
						}
			}


		},
        getJWT(n) {
			this.getAction({
				url: jwtToken.phoneGetJwt,
				params: {
					phone: ls.get('jwtphone')
				}
			}).then((res) => {
				if (res) {
					ls.set('jwtMain', res)
					setTimeout(() => {
						if (n == 1) {
							this.goMore('/EnterpriseSealService/Add', this.form.phoneNumber, 'add')
						} else if (n == 2) {
							this.goMore('/EnterpriseSealService', this.form.phoneNumber, 'list')
						}
					}, 50);
				}
			})
		},
        subPhone() {
			axios({
				method: 'get',
				url: kaptcha.generatekaptcha,
				responseType: 'blob',
				params: {
					phone:this.form.phoneNumber
				}
			}).then(res => {
				const blob = new Blob([res.data], { type: "application/vnd.ms-excel;charset=utf-8" });
				this.kaptcha = window.URL.createObjectURL(blob)
				this.isShow = true;
			})
		},
		onChangePass() {
			const ele = this.$refs.editPasswordModal;
			ele.form = Object.assign({}, {});
			ele.visible = true;
        },
        onLogout() {
			let self = this;
			self.$confirm({
				title: '确认要退出登录?',
				content: '',
				onOk() {
					self.postAction({
						url: login_mp.saveLog,
						params: { logAppCategoryEnum: "LOGOUT" }
					}).then(res => {
						console.log(res)
						self.getAction({
							url: login_mp.logout,
							params: { access_token: ls.get("token") || "" },
							isValid: false
						}).then(() => {
							self.$notification['success']({
								message: '退出成功',
								style: {
									fontWeight: '600',
								},
							});
						})
					})


					setTimeout(() => {
						self.logout();
					}, 2000)
				},
				onCancel() {
					console.log(503);
				},
			});
		},
        logout() {
			let self = this;

			self.$ls.clear();
			self.$store.commit('setMenuData', []);
			self.$router.replace('/');

			location.reload();
		},
        islogin() {
			if (ls.get('token') && ls.get("refresh_token")) {
				if (ls.get("roleCode").includes('company')) {
					this.goMore('/sys/userIndex')
				} else if (ls.get("roleCode").includes('technicalManager')) {
					this.goMore('/sys/technology/person');
				} else if (ls.get("roleCode").includes('serviceOrganization')) {
					this.goMore('/sys/innovation/organization/index');
				} else if (ls.get("roleCode").includes('investorManager')) {
					this.goMore('/finance/investorInformation');
				} else if (ls.get("roleCode").includes('investmentMechanism')) {
					this.goMore('/finance/investmentOrganizationInformation');
				} else if (ls.get("roleCode").includes('financialAdviser')) {
					this.goMore('/finance/financialAdvisorInformation');
				} else if (ls.get("roleCode").includes('bank')) {
                    this.goMore('/finance/financingInstitutionInformation');
                }else if(ls.get("roleCode").includes('expert')){
                    this.goMore('/sys/userIndex');
                } else if(ls.get("roleCode").includes('gov-institution')){
                    this.goMore("/sys/govInstitution")
                }else {
					this.goMore('/sys/userInfo')
				}
			} else {
				this.goMore('/login', 'user')
			}
		},
        valiJWT() {
			this.getAction({
				url: jwtToken.JwtCheck,
				params: {
					phone: ls.get('jwtphone'),
					jwt: ls.get('jwtMain')
				}
			}).then((res) => {
				console.log(res,1442);
				this.chapterShow=true
				if (res) {
					this.valiJWTShow = false
					this.SealServiceShow = 1;this.form.phoneNumber = ls.get('jwtphone')
				} else {
					this.valiJWTShow = true
					this.SealServiceShow =1;this.form.watmal = null; this.form.phoneNumber = null
				}
			})
		},
        getLink() {
			this.getAction({
				url: getWLinkPage.pageList
			}).then(res => {
				let arr = []
				res.records.map(item => {
					if (item.fname && item.furl) {
						arr.push(item)
					}
				})
				this.linkData = arr
			})
		},
        goMore(url, str, gourl) {
			this.$router.push({ path: url, query: { id: str, gourl: gourl } })
		},
        goMorePolicy(type) {
			this.$router.push({
				path: '/notice',
				query: { type: type }
			})
		},
        goMoreNotice(url, str) {
			this.$router.push({ path: url, query: { ...str } })
		},
        goHttp(url) {
			window.open(url, '_bank')
		},
        goProjectReview(){
            this.goMore("/projectReview")
            /*if (ls.get('token') && ls.get("refresh_token")){
                this.goMore("/projectReview")
            }else{
                this.goMoreNotice('/register',{role:'014'})
            }*/

        },
        goJump(url){
            this.$router.push({
				path:url,
			})
        }
	},
}
</script>

<style scoped lang="less">
.indexCenter{
	width: 1200px;
	margin:0 auto;
}
.index-top{
	.index-banner{
		height:280px;
		background-image: url('../../../assets/home/home-banner.png');
		background-size:cover;
        background-repeat: no-repeat;
		.banner-top{
			padding-top:16px;
			display:flex;
			align-items:center;
			justify-content:space-between;
			a{
				font-size:16px;
				color:#104460;
			}
			a:hover{
				color:#40a9ff;
			}
			.lineBox {
				width: 1px;
				height: 10px;
				background: #34586b;
			}

		}
		.banner-user{
			color:#104460;
			.rightBox {
					padding:5px 20px;
					float: right;
					display: flex;
					justify-content: space-around;
					align-items:center;
					// line-height: 92px;
					font-size: 16px;
					background-color:#f00;
					background: rgba(0, 89, 181, 0.1);
					border-radius: 50px;
					// opacity: 0.1;
				a {
					font-weight: 600;
				}

				.loginBox {
					// float: left;
					cursor: pointer;
				}

				.loginBox:hover {
					color: #fc550b;
				}


				.resigierBox {
					cursor: pointer;
					// float: left;
				}

				.resigierBox:hover {
					color: #fc550b;
				}
			}
		}

		.home-logo{
			margin-top:60px;
			img{
				height:52px;
                cursor: pointer;
			}
		}
	}
    .indexBanner2{
        height:160px;
        background-position-y:bottom;
        .home-logo{
            margin-top:30px;
        }
    }

	.index-nav{
		background-color:#3264da;
		ul{
			display:grid;
			grid-template-columns:repeat(5,1fr);
			font-size:20px;
			color:#fff;
			li{
				position: relative;
				display:flex;
				align-items:center;
				justify-content:center;
				line-height:60px;
				cursor: pointer;
				&::after{
					position:absolute;
					right:-1px;
					display:inline-block;
					content:'';
					width:1px;
					height:20px;
					background-color:rgba(255, 255, 255, 0.4);
				}
				a{
					display:block;
					width:100%;
					height:100%;
					text-align:center;
					color:#fff;
				}
			}
			li:last-child{
				&::after{
					display:none;
				}
			}
			.liSelect{
				position: relative;
				background-color:#0f4eb4;

				&::before{
					position:absolute;
					bottom:0;
					display:block;
					content:'';
					width:0;
					height:0;
					border-left: 6px solid transparent;
					border-right: 6px solid transparent;
					border-bottom: 6px solid #fff;

				}
			}
		}
	}
    .hearder-line{
        height:10px;
        background-color:#3264da;
    }

}
.login-form{
	padding:30px 0;
	position: relative;
}
.tipphone{
	margin-bottom:20px;
	color: red;
}
.SealServiceActive {
	display: block !important;
}


.codeBtnWordMark {
	width: 100%;
	height: 30px;
	background: rgba(136, 135, 135, 0.6);
	position: absolute;
	left: 0;
	top: 0;
	z-index: -1;
}

:deep(.ant-btn) {
	color: #40a9ff;
	font-weight: 600;
	padding: 0 10px;
	border-color: #40a9ff;

	img {
		margin-right: 5px
	}

	&:focus {
		background-color: #40a9ff;
		color: #fff;
		border-color: none;
		box-shadow: 1px 1px 5px 1px #a7a7a7;
	}

	&:hover {
		background-color: #40a9ff;
		color: #fff;
		border-color: none;
		box-shadow: 1px 1px 5px 1px #a7a7a7;
	}
}
:deep(.ant-list-lg .ant-list-item) {
    padding: 12px 8px;
}
:deep(.ant-list-empty-text){
    padding: 10px;
}
:deep(.ant-empty-normal){
    margin: 0;
}
:deep(.ant-col){
    max-width:100% !important;
}
</style>
